import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import Modal from "../../common/components/ThemedModal";
import { MdPlaylistAdd } from "react-icons/md";
import { initialSeries, Series, Sport } from "../../../types/model";
import { useAppSelector } from "../../../store/hooks";
import { RootState } from "../../../store/store";
import {
	getEventSeries,
	getFutureEvents,
	getSportsByEventsAndSeries,
} from "../../../utils/helper";

interface CreateTeamModalProps {
	showCreateTeam: boolean;
	setShowCreateTeam: (show: boolean) => void;
	handleCreateTeam: (sport: Sport, series: Series) => void;
}

const CreateTeamModal: React.FC<CreateTeamModalProps> = ({
	showCreateTeam,
	setShowCreateTeam,
	handleCreateTeam,
}) => {
	const { events } = useAppSelector((state: RootState) => state.fantasy);

	const [seriesDropdown, setSeriesDropdown] = useState<Series | null>(null);
	const [sportsDropdown, setSportsDropdown] = useState<Sport | null>(null);

	const seriesList = getEventSeries(getFutureEvents(events));
	const sports = getSportsByEventsAndSeries(
		getFutureEvents(events),
		seriesDropdown ?? initialSeries,
	);

	const createTeam = () => {
		if (seriesDropdown && sportsDropdown) {
			handleCreateTeam(sportsDropdown, seriesDropdown);
			setShowCreateTeam(false);
		} else {
			alert("Please select a series and sport.");
		}
	};

	const handleSeriesChange = (e: React.ChangeEvent<any>) => {
		const target = e.target as HTMLSelectElement;
		setSeriesDropdown(
			seriesList.find((series) => series._id === target.value) || null,
		);
	};

	return (
		<Modal show={showCreateTeam} onHide={() => setShowCreateTeam(false)}>
			<Modal.Header closeButton >
				<Modal.Title>
					<MdPlaylistAdd className="me-2 mb-1" /> Create a Team
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>Choose a series and sport</p>
				<Form.Group>
					<Form.Label>Series</Form.Label>
					<Form.Control
						as="select"
						value={seriesDropdown?._id || ""}
						onChange={handleSeriesChange}
					>
						<option value="">Select a series</option>
						{seriesList.map((series) => (
							<option key={series._id} value={series._id}>
								{series.name}
							</option>
						))}
					</Form.Control>
				</Form.Group>
				<Form.Group>
					<Form.Label>Sports</Form.Label>
					<Form.Control
						as="select"
						value={sportsDropdown?._id || ""}
						onChange={(e: React.ChangeEvent<any>) =>
							setSportsDropdown(
								sports.find(
									(sport) =>
										sport._id === (e.target as HTMLSelectElement).value,
								) || null,
							)
						}
					>
						<option value="">Select a sport</option>
						{sports.map((sport) => (
							<option key={sport._id} value={sport._id}>
								{sport.name}
							</option>
						))}
					</Form.Control>
				</Form.Group>
			</Modal.Body>
			<Modal.Footer>
				<Button
					variant="outline-secondary"
					onClick={() => setShowCreateTeam(false)}
				>
					Close
				</Button>
				<Button
					variant="primary"
					onClick={() => {
						createTeam();
					}}
				>
					Create
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default CreateTeamModal;
